import { ColumnsType } from "antd/lib/table";

export type InventoryRow = {
  key: string;
  asin: string;
  shipType: string;
  availableFBA: number;
  receivingFBA: number;
  available3PL: number;
  inTransit: number;
  allAvailable: number;
  sales30: number;
  doi: number;
  poUnitsForecast: number;
};

export const inventoryColumns: ColumnsType<InventoryRow> = [
  { title: "ASIN", dataIndex: "asin", key: "asin" },
  { title: "Ship. Type", dataIndex: "shipType", key: "shipType" },

  {
    title: "Available units FBA",
    dataIndex: "availableFBA",
    key: "availableFBA",
    align: "right",
  },
  {
    title: "Receiving FBA",
    dataIndex: "receivingFBA",
    key: "receivingFBA",
    align: "right",
  },
  {
    title: "Available units 3PL",
    dataIndex: "available3PL",
    key: "available3PL",
    align: "right",
  },
  {
    title: "In transit",
    dataIndex: "inTransit",
    key: "inTransit",
    align: "right",
  },

  {
    title: "All available units + shipping",
    dataIndex: "allAvailable",
    key: "allAvailable",
    align: "right",
  },
  {
    title: "Sales 30 days",
    dataIndex: "sales30",
    key: "sales30",
    align: "right",
  },
  { title: "DOI", dataIndex: "doi", key: "doi", align: "right" },
  {
    title: "PO Units (forecast)",
    dataIndex: "poUnitsForecast",
    key: "poUnitsForecast",
    align: "right",
  },
];

export const inventoryData: InventoryRow[] = [
  {
    key: "B0D15LQ983",
    asin: "B0D15LQ983",
    shipType: "Train",
    availableFBA: 4_718,
    receivingFBA: 9_259,
    available3PL: 0,
    inTransit: 10_152,
    allAvailable: 24_129,
    sales30: 8_005,
    doi: 91,
    poUnitsForecast: 16_010,
  },
  {
    key: "B0DF37MWWM",
    asin: "B0DF37MWWM",
    shipType: "Train",
    availableFBA: 1_981,
    receivingFBA: 5_765,
    available3PL: 0,
    inTransit: 3_060,
    allAvailable: 10_806,
    sales30: 2_926,
    doi: 111,
    poUnitsForecast: 0,
  },
  {
    key: "B0DF36CMY8",
    asin: "B0DF36CMY8",
    shipType: "Train",
    availableFBA: 346,
    receivingFBA: 1_472,
    available3PL: 0,
    inTransit: 2_060,
    allAvailable: 4_876,
    sales30: 1_700,
    doi: 87,
    poUnitsForecast: 3_399,
  },
  {
    key: "B0D7JKYM5",
    asin: "B0D7JKYM5",
    shipType: "Train",
    availableFBA: 1_748,
    receivingFBA: 2_633,
    available3PL: 0,
    inTransit: 3_060,
    allAvailable: 7_441,
    sales30: 1_670,
    doi: 134,
    poUnitsForecast: 0,
  },
  {
    key: "B0DGXVJ494",
    asin: "B0DGXVJ494",
    shipType: "Air",
    availableFBA: 1_243,
    receivingFBA: 0,
    available3PL: 0,
    inTransit: 0,
    allAvailable: 1_243,
    sales30: 1_477,
    doi: 26,
    poUnitsForecast: 2_954,
  },
  {
    key: "B0DM9KHJBC",
    asin: "B0DM9KHJBC",
    shipType: "Air",
    availableFBA: 2,
    receivingFBA: 360,
    available3PL: 0,
    inTransit: 720,
    allAvailable: 1_082,
    sales30: 914,
    doi: 36,
    poUnitsForecast: 1_827,
  },
  {
    key: "B0D5MNJWR9",
    asin: "B0D5MNJWR9",
    shipType: "Train",
    availableFBA: 883,
    receivingFBA: 1_021,
    available3PL: 0,
    inTransit: 3_420,
    allAvailable: 5_324,
    sales30: 727,
    doi: 220,
    poUnitsForecast: 0,
  },
  {
    key: "B0D8WPPF56",
    asin: "B0D8WPPF56",
    shipType: "Air",
    availableFBA: 1_813,
    receivingFBA: 0,
    available3PL: 0,
    inTransit: 0,
    allAvailable: 1_813,
    sales30: 670,
    doi: 82,
    poUnitsForecast: 1_339,
  },
  {
    key: "B0D7J3NY2",
    asin: "B0D7J3NY2",
    shipType: "Train",
    availableFBA: 264,
    receivingFBA: 0,
    available3PL: 0,
    inTransit: 900,
    allAvailable: 1_164,
    sales30: 342,
    doi: 102,
    poUnitsForecast: 686,
  },
  {
    key: "B0D7JRC5P",
    asin: "B0D7JRC5P",
    shipType: "Sea",
    availableFBA: 726,
    receivingFBA: 89,
    available3PL: 0,
    inTransit: 0,
    allAvailable: 815,
    sales30: 299,
    doi: 82,
    poUnitsForecast: 597,
  },
];
